import React from 'react';
import { Link, Text } from '@goodfynd/react-web.lib.ui';
import { useRouter } from 'next/router';

import config from '../../../config';
import { numberUtil, stringUtil } from '../../../utils';

import {
  StyledCardBody,
  StyledCardContent,
  StyledImageContainer,
  StyledPrice,
  StyledProductCard,
} from './styles';
import type { VendorProductCardProps } from './types';

import classes from './VendorProductCard.module.css';

export default function VendorProductCard({
  data,
  onProductClick,
  vendorNameId,
}: VendorProductCardProps) {
  const router = useRouter();

  return (
    <StyledProductCard>
      <Link
        className={classes['card-link']}
        href="#!"
        onClick={() => {
          if (onProductClick) {
            return onProductClick(data);
          }

          if (router.pathname.includes('schedules') && router.query.id) {
            const scheduleId = router.query.id as string;
            router.push(
              stringUtil.replaceAll(config.routes.schedules.product, {
                ':id': data.id,
                ':scheduleId': scheduleId,
              }),
              undefined,
              { shallow: true }
            );
          } else {
            if (!vendorNameId) {
              return;
            }

            router.push(
              stringUtil.replaceAll(config.routes.products.details, {
                ':id': data.id,
                ':vendorId': vendorNameId,
              }),
              undefined,
              { shallow: true }
            );
          }
        }}
      >
        <StyledCardBody>
          <StyledCardContent>
            <div>
              <Text as="subhead2">{data.name}</Text>
              <Text as="body2" truncate={2}>
                {data.description}
              </Text>
            </div>

            <StyledPrice>
              {data.price.value > 0
                ? numberUtil.renderPrice(data.price.value)
                : 'no price'}
            </StyledPrice>
          </StyledCardContent>

          {data.image && (
            <StyledImageContainer
              css={{
                backgroundImage: `url(${data.image})`,
              }}
            />
          )}
        </StyledCardBody>
      </Link>
    </StyledProductCard>
  );
}
